/* eslint-disable @typescript-eslint/no-explicit-any */
export function coerceBoolean(value: any): boolean {
  return value != null && `${value}` !== 'false';
}

export function coerceNumber(value: any): number;
export function coerceNumber<D>(value: any, fallback: D): number | D;
export function coerceNumber(value: any, fallbackValue = 0) {
  if (isNumberValue(value)) {
    return Number(value);
  }
  return arguments.length === 2 ? fallbackValue : 0;
}

function isNumberValue(value: any): boolean {
  // SAFETY(legacy): unreviewed, pre-dates this rule.
  return !isNaN(parseFloat(value as any)) && !isNaN(Number(value));
}

export function coerceArray<T>(value: T | T[]): T[];
export function coerceArray<T>(value: T | readonly T[]): readonly T[];
export function coerceArray<T>(value: T | T[]): T[] {
  return Array.isArray(value) ? value : [value];
}

export function coerceStringArray(value: any, separator: string | RegExp = /\s+/): string[] {
  const result: string[] = [];

  if (value != null) {
    const sourceValues = Array.isArray(value) ? value : `${value}`.split(separator);
    for (const sourceValue of sourceValues) {
      const trimmedString = `${sourceValue}`.trim();
      if (trimmedString) {
        result.push(trimmedString);
      }
    }
  }

  return result;
}
